import { ColumnConfigurationRenderAs } from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

const S9PageSection = ui.S9PageSection.default;
const { Grid } = ui;

export function HealthScreenQuestionsListView({
  healthScreenId,
}: {
  healthScreenId: number;
}) {
  return (
    <S9PageSection size="sm">
      <Grid
        name="health_question_list"
        searchQueryKey="gethealthquestionsbyhealthscreenbyid"
        queryVars={{
          id: healthScreenId,
        }}
        showTotal
        columnsConfiguration={[
          {
            label: '#',
            field: 'id',
            value: '{{id}}',
            renderAs: ColumnConfigurationRenderAs.Text,
          },
          {
            label: 'Question',
            field: 'question_text',
            value: '{{question_text}}',
            renderAs: ColumnConfigurationRenderAs.Text,
          },
          {
            label: 'Subscale',
            field: 'subscale',
            value: '{{subscale}}',
            renderAs: ColumnConfigurationRenderAs.Text,
          },
          {
            label: 'Response',
            field: 'response',
            value: '{{response}}',
            renderAs: ColumnConfigurationRenderAs.Text,
          },
          {
            label: 'Score',
            field: 'score',
            value: '{{score}}',
            renderAs: ColumnConfigurationRenderAs.Text,
          },
        ]}
      />
    </S9PageSection>
  );
}
